import {SyncstepId} from "../../constants";
import {ICompanySyncstep} from "../../index";

export class SyncStepValidator {

    private data: Partial<Record<keyof ICompanySyncstep, { support: boolean | null, message?: string }>>

    constructor(private companySyncstep: ICompanySyncstep, private eHubSupport: boolean) {
        this.data = {
            customerkey: {
                support: this.companySyncstep.syncstep.supportsconfigkey,
            },
            filters: {
                support: this.companySyncstep.syncstep.isexportable,
            },
            eHubForm: {
                support: null, // set below from constructor arg
                message: `the organization does not support this setting`,
            },
            importanchorsbeforesync: {
                support: [SyncstepId.Export_Azure, SyncstepId.Export_Azure_2].includes(this.companySyncstep.syncstep.id),
                message: `it is only name that supports this setting|name:Export Azure`,
            },
            passwordexport: {
                support: this.companySyncstep.syncstep.supportspasswordexport,
            },
            system: {
                support: this.companySyncstep.syncstep.supportsconfigkey,
            },
        }
        this.data.eHubForm!.support = eHubSupport
    }

    public isSupported(attr: keyof ICompanySyncstep): boolean {
        const entry = this.data[attr];
        if (entry) {
            return entry.support ?? true
        }
        return true
    }

    public getMessage(attr: keyof ICompanySyncstep): string | null {
        const entry = this.data[attr];
        if (entry) {
            return entry.message?.replace('{{syncstep.name}}', `<code>${this.companySyncstep.syncstep.name}</code>`) ?? null
        }
        return null
    }

}